import UIDs from "../../../../UIDs";

const uid = UIDs.screens.talkchinese.practiceresult;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    UPDATE_UNIT_RESULT_ASYNC: `${uid}.updateUnitResultAsync`,
    UPDATE_UNIT_RESULT_SUCCESS: `${uid}.updateUnitResultSuccess`,
    UPDATE_UNIT_RESULT_FAILURE: `${uid}.updateUnitResultFailure`,
};

export { ActionTypes };